<template lang="html">
  <div class="section-swiper-slide section-bar-font" @click="changePage">
    {{ section.name }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['section'],
  data () {
    return {}
  },
  mounted () {
    this.applySettings(this.settings)
  },
  computed: {
    ...mapGetters({
      currentSection: 'getCurrentSection',
      sections: 'getSections',
      currentPage: 'getCurrentPage',
      settings: 'getSettings'
      // sportsXtraMenuSelected: 'getSportsExtraMenuSelected'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    },
    currentSection: function (newValue) {
      if (newValue === this.section) {
        this.clearOtherSections()
        this.setSelectedColors()
      }
    },
    // sportsXtraMenuSelected: function (newValue) {
    //   if (newValue && this.section.name.toUpperCase() === 'SPORTSXTRA') {
    //     this.changePage()
    //     this.$store.commit('setSportsExtraMenuSelected', false)
    //   }
    // },
    '$route': function (newValue, oldValue) {
      if (oldValue.name === 'articles' || oldValue.name === 'articles-mobile') {
        this.$nextTick(function () {
          if (this.currentSection === this.section) {
            this.clearOtherSections()
            this.setSelectedColors()
          }
        })
      }
    },
    sections: function () {
      this.$nextTick(function () {
        this.applySettings(this.settings)
      })
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined) {
        if (this.currentSection !== undefined) {
          if (this.section === this.currentSection) {
            this.clearOtherSections()
            this.setSelectedColors()
          }
        }
        var sectionsElem = document.getElementsByClassName('section-swiper-slide')
        for (var i = 0; i < sectionsElem.length; i++) {
          if (settings.sectionsBarTextUpperCase) {
            sectionsElem[i].style.textTransform = 'uppercase'
          }
        }
      }
    },
    changePage () {
      this.clearOtherSections()
      this.setSelectedColors()
      this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesGroupNavigationSelect', undefined, this.section.name)
      this.$store.commit('setTransitionToPage', this.section.pages[0])
      this.$store.commit('setCurrentSection', this.section)
    },
    setSelectedColors () {
      if (this.settings !== undefined) {
        this.$el.style.color = this.settings.sectionsBarBackgroundColor
        this.$el.style.background = this.settings.sectionsBarTextColor
      }
    },
    clearOtherSections () {
      if (this.settings !== undefined) {
        var sectionsElem = document.getElementsByClassName('section-swiper-slide')
        for (var i = 0; i < sectionsElem.length; i++) {
          sectionsElem[i].style.color = this.settings.sectionsBarTextColor
          sectionsElem[i].style.background = this.settings.sectionsBarBackgroundColor
        }
      }
    }
  }
}
</script>

<style lang=scss>
@import 'helpers/_colors-and-mixins.scss';
.section-swiper-slide {
  float: left;
  height: 100%;
  margin: 0 1px 0 0;
  padding-left: 30px;
  padding-right: 30px;
  color: $wet-asphalt;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  height: 37px;
  line-height: 37px;

  @include respond-to(phone){
    /* width:100px; */
  }
}
</style>
